import { PromotionContestRewardType, PromotionContestV2 } from './types/ContestTypes';

export function newContestV2ClientId(): string {
  return `ct2_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}

export const CONTEST_V2_MAX = {
  triggerIdentifier: 64,
  branchName: 64,
  title: 100,
  message: 255,
} as const;

export function createEmptyContestV2Branch() {
  return {
    id: newContestV2ClientId(),
    branchName: '',
    stepIndex: 0,
  };
}

export function createEmptyContestV2Episode() {
  return {
    id: newContestV2ClientId(),
    episodeUuid: '',
    branches: [createEmptyContestV2Branch()],
  };
}

export function createEmptyContestV2Values(): PromotionContestV2 {
  return {
    triggerIdentifier: '',
    episodes: [],
    title: '',
    message: '',
    rewardType: PromotionContestRewardType.Sapphires,
    rewardAmount: 0,
  };
}

export function v2RewardFieldsFromApiAmounts(
  sapphiresAmount: number,
  heartsAmount: number,
): Pick<PromotionContestV2, 'rewardType' | 'rewardAmount'> {
  const s = Number(sapphiresAmount) || 0;
  const h = Number(heartsAmount) || 0;
  if (s > 0) return { rewardType: PromotionContestRewardType.Sapphires, rewardAmount: s };
  if (h > 0) return { rewardType: PromotionContestRewardType.Hearts, rewardAmount: h };
  return { rewardType: PromotionContestRewardType.Sapphires, rewardAmount: 0 };
}

export function isContestV2Populated(v: PromotionContestV2): boolean {
  if (String(v.title ?? '').trim() || String(v.message ?? '').trim()) return true;
  if (Number(v.rewardAmount) > 0) return true;
  for (const ep of v.episodes ?? []) {
    if (String(ep.episodeUuid ?? '').trim()) return true;
    for (const b of ep.branches ?? []) {
      if (String(b.branchName ?? '').trim()) return true;
    }
  }
  return false;
}

export function buildTriggerDataFromV2Episodes(
  episodes: PromotionContestV2['episodes'],
): Record<string, Record<string, number>> {
  const out: Record<string, Record<string, number>> = {};
  for (const ep of episodes) {
    const uuid = String(ep.episodeUuid ?? '').trim();
    if (!uuid) continue;
    const branchMap: Record<string, number> = {};
    for (const b of ep.branches ?? []) {
      const bn = String(b.branchName ?? '').trim();
      if (!bn) continue;
      branchMap[bn] = Number(b.stepIndex) || 0;
    }
    if (Object.keys(branchMap).length > 0) {
      out[uuid] = branchMap;
    }
  }
  return out;
}
